import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom';
import Footer from '../../Components/Footer'
import Header from '../../Components/Header'
import axios from 'axios'
import { useForm } from "react-hook-form";
import { Oval } from 'react-loader-spinner'
import {baseUrl, TOKEN_KEY} from '../../constants'
import { appContext } from '../../Context/appProvider';
import { useNavigate } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { settingsContext } from '../../Context/settingsProvider';

export default function Login() {
  const {setToken} = useContext(appContext)
  const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm();
  const [signupMethod, setSignupMethod] = useState({method: 'phone', value: '', action: 'phonelogin'})
  const [step, setStep] = useState(1) // 1 phpne/email, 2 - otp, 3 - information
  const navigate = useNavigate()
  const [error, setError] = useState(null)
  const [otp, setOtp] = useState('');
  const [otpChecking, setOtpChecking] = useState(false)
  const isEmail = signupMethod.method == 'email'
  const {t} = useContext(settingsContext)

  const onSubmit = data => {
    console.log(data)
    return new Promise((resolve, reject) => {
      // const path = signupMethod.method == 'phone' ? '/send-otp' : '/login'
      setError()
      axios(baseUrl + '/api/common' + '/login', {
        method: 'post',
        data: {
          ...data,
          method: isEmail ? "email" : 'phone'
        }
      }).then(response => {
        const data = response.data
        resolve(true)
        console.log(response.data)
        if(data.success){
          localStorage.setItem(TOKEN_KEY, response.data.token)
          setToken(data.token)
          navigate('/')
        } else setError(data.message)
      })
      .catch(e => {
        resolve(true)
        setError('Network Error')
      })
    })
  }

  const changeMethod = (method) => {
    setSignupMethod(s => ({...s, method}))
  }

  const onOtpChange = (value) => {
    setOtp(value)
    if(value.length == 4){
      setOtpChecking(true)
      axios(baseUrl + '/api/common/verify', {
        method: 'post',
        data: {
          code: value,
          identifier: signupMethod.value,
          action: 'phonelogin'
        }
      }).then(response => {
        const data = response.data
        if(data.success){
          localStorage.setItem(TOKEN_KEY, response.data.token)
          setToken(data.token)
          navigate('/')
        } else setError('Invalid Code!')
      }).finally(() => setOtpChecking(false))
    }
  }

  return (
    <div className='w-full h-screen flex flex-col pt-[60px] overflow-x-hidden'>
      <Header withLogo />
      <form onSubmit={handleSubmit(onSubmit)} className='flex-1 flex flex-col gap-5 items-center pt-10 pb-10'>
      {error && (
        <p className='bg-[#f946464f] text-[#f94646] text-[15px] font-bold px-10 py-2 rounded-sm'>
          {error}
        </p>
      )}

        {(step == 2 && !error) &&  <p className='bg-[#36af014f] text-[#1a6500] text-[15px] font-bold px-10 py-2 rounded-sm'>OTP Sent!</p>}
        {step == 1 && <div className='rounded-[30px] p-2 bg-[#00000030] shadow-md'>
          <button onClick={() => changeMethod('phone')} className={`rounded-[30px] px-4 py-1 border-none outline-none ${!isEmail ? 'bg-black text-white' : 'bg-none text-black'}`} type='button'>
            {t('PHONE')}
          </button>
          <button onClick={() => changeMethod('email')} className={`rounded-[30px] px-4 py-1 border-none outline-none ${isEmail ? 'bg-black text-white' : 'bg-none text-black'}`} type='button'>
            {t('EMAIL')}
          </button>
        </div> }
        <h3 className='text-black  text-[20px uppercase'>{t('LOGIN')}</h3>
        { signupMethod.method == 'email' ? (
          <>
            <input {...register('email')} placeholder={t('EMAIL')} type='text' className='text-black border-[1px] border-black rounded-md w-[400px] max-md:w-[300px] p-2 pl-4' required />
            <input {...register('password')} placeholder={t('PASSWORD')} type='password' className='text-black border-[1px] border-black rounded-md w-[400px] max-md:w-[300px] p-2 pl-4' required />
          </>
        ) : step == 1 ? (
          <>
            <input  {...register('phone')} placeholder={t('PHONE') + ' (09xxxxxxxx)'} type={'number'} className='text-black border-[1px] border-black rounded-md w-[400px] max-md:w-[300px] p-2 pl-4' required />
            <input {...register('password')} placeholder={t('PASSWORD')} type='password' className='text-black border-[1px] border-black rounded-md w-[400px] max-md:w-[300px] p-2 pl-4' required />
          </>
        ) : (
          <></>
          // <OtpInput
          //   value={otp}
          //   onChange={onOtpChange}
          //   numInputs={4}
          //   inputStyle={'border-[1px] border-black p-3 !w-[40px] rounded-md'}
          //   renderSeparator={<span style={{marginLeft: 5, marginRight: 5 }}></span>}
          //   renderInput={(props) => <input style={{border: '1px sold #000000'}} {...props} />}
          // />
        )}

        {step != 2 && <button className='bg-main w-[400px] max-md:w-[300px] text-white text-[20px] rounded-md p-2 flex items-center justify-center' type='submit'>
          {isSubmitting ? (
            <Oval
            visible={true}
            height="30"
            width="30"
            color="#ffffff"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
            strokeWidth={3}
            />
          ) : t('LOGIN')}
          </button> }
          {otpChecking && (
            <Oval
            visible={true}
            height="30"
            width="30"
            color="#6622cf"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
            strokeWidth={3}
            />
          )}
        <hr className='w-full text-[#00000040]'/>
        <div className='w-full flex items-center justify-center px-6'>
          <Link to='/signup' className='text-[13px] text-[#4848ff]'>{t('NEW_HERE')}</Link>
        </div>
      </form> 
      <Footer />
    </div>
  )
}